import cn from 'classnames';
import join from 'url-join';
import Cookie from 'js-cookie';
import type { ChangeEvent } from 'react';
import { OptimizelyDecideOption as Options } from '@optimizely/optimizely-sdk';
import { useOptimizely } from '@libs/common-next';
import { useOverrides } from '../../store';
import type { Flag } from '../../types';
import css from './flag.module.scss';

interface Props {
    flag: Flag;
}
export function FeatureFlag({ flag }: Props) {
    const { context, instance } = useOptimizely();
    const { overrides, setOverride } = useOverrides();

    const override = Object.keys(overrides).includes(flag.key);
    const original = context?.decide(flag.key, [Options.DISABLE_DECISION_EVENT])
        ?.variables.value as string;

    const onChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const value = { ...overrides, [flag.key]: e.target.value };

        Cookie.set('x-petm-override', JSON.stringify(value));
        setOverride(value);
    };

    return (
        <div className={css.flag}>
            <div>
                <a
                    target="_blank"
                    className={css.name}
                    href={join(
                        'https://app.optimizely.com/v2/projects',
                        `${instance?.getProjectConfig()?.projectId}`,
                        '/flags/manage',
                        flag.key,
                        '/variations'
                    )}
                >
                    {flag.key}
                </a>

                <span className={cn(css.tag, { [css.ab]: flag.isAbTest })}>
                    {flag.isAbTest ? '✦ A/B Test' : '❖ Targeted Delivery'}
                </span>

                {override && (
                    <span className={cn(css.tag, css.override)}>
                        ∅ {original}
                    </span>
                )}
            </div>

            <select
                id={flag.id}
                className={css.select}
                value={overrides[flag.key] ?? original}
                onChange={onChange}
            >
                <button>
                    {/* @ts-expect-error -- new api */}
                    <selectedcontent></selectedcontent>
                    <span className={css.icon}>⌃</span>
                </button>
                {flag.options.map(o => (
                    <option key={o} value={o}>
                        {o}
                    </option>
                ))}
            </select>
        </div>
    );
}
